export default __webpack_public_path__ + "static/media/screenContent2.353e299d.jpg";